
<div class="header pt-2" :class="headerClass">
  <div class="pl-0 pr-0">
    <div :class="{ 'header-body': true, 'without-underline': ! underline }">
      <slot />
    </div>
  </div>
</div>
